import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";

export class ListSeparator extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        super(scene);

        this.scene = scene;
        this.height = 10;

        const sep = SpriteUtils.addSprite(this.scene!, 0, 5, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5).setOrigin(0.5, 0.5);

        this.add(sep);
    }

}
